import React, { useState, useEffect } from "react";
import kamlaLogo from '../assests/kamlaLogo.png';
import { API_BASE } from "../config"; 

// Utility: Date Formatting
function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

const Receipt = ({ show, data, companyDetails, onClose }) => {
  const [showHeader, setShowHeader] = useState(true);
  
  // ✅ Ab hum yahan footerText ki jagah pura settings object save karenge
  const [settings, setSettings] = useState(null);

  // ✅ Fetching Settings for Footer Text
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = sessionStorage.getItem('token'); 
        const response = await fetch(`${API_BASE}/Settings`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
          }
        });
        
        if (response.ok) {
          const result = await response.json();
          setSettings(result); // Pura object store kar liya
        }
      } catch (error) {
        console.error("Error fetching receipt footer settings:", error);
      }
    };

    if (show) {
      fetchSettings();
    }
  }, [show]);

  if (!show || !data || !companyDetails) return null;

  const handlePrint = () => {
    window.print();
  };

  const handleToggleHeader = () => {
    setShowHeader(!showHeader);
  };

  // --- Data Mapping ---
  const patientName = data.name || data.patientName || data.PatientName || "";
  const uhid = data.uhidNo || data.UHID_No || data.uhiD_No || "-";
  const mobile = data.mobileNo || data.MobileNo || "";
  const ageGender = `${data.age || "-"}/${data.gender || "-"}`;
  const doctorName = data.consultantName || data.doctorName || "Dr. .......................";
  const regDateFormatted = formatDateToDDMMYYYY(data.regDate || data.opdDate || data.ipD_Date || new Date());

  // ✅ DYNAMIC ID LOGIC SE HUM VISIT TYPE BHI NIKALENGE
  let receiptLabel = "Receipt No";
  let receiptNo = "-";
  let detectedVisitType = "OPD"; // Default rakh lete hain

  if (data.opD_SRNO || data.OPD_SRNO || data.opdId) {
      receiptLabel = "OPD Id";
      receiptNo = data.opD_SRNO || data.OPD_SRNO || data.opdId;
      detectedVisitType = "OPD"; // Pehchan liya ki ye OPD hai
  } else if (data.ipD_SRNO || data.IPD_SRNO || data.ipD_ID || data.IPD_ID) {
      receiptLabel = "IPD Id";
      receiptNo = data.ipD_SRNO || data.IPD_SRNO || data.ipD_ID || data.IPD_ID;
      detectedVisitType = "IPD"; // Pehchan liya ki ye IPD hai
  } else {
      receiptNo = data.id || "-";
  }

  // ✅ Ab Detected Visit Type ke hisaab se Footer Text nikalenge
  let currentFooterText = "";
  if (settings) {
      if (detectedVisitType === "OPD") {
          currentFooterText = settings.opdReceiptFooterText || "";
      } else if (detectedVisitType === "IPD") {
          currentFooterText = settings.ipdReceiptFooterText || "";
      }
  }

  // Vitals Extraction
  const vitals = {
    Weight: data.weights || data.weight || "",
    Height: data.heights || data.height || "",
    BP: data.bp || data.BP || "",
    Pulse: data.pulses || data.pulse || "",
    Temp: data.temps || data.temperature || "",
    SPO2: data.oxy || data.oxygen || "",
    RBS: data.rbs || data.RBS || ""
  };

  // 🌐 Base URL for dynamic images
  const getImageUrl = (path) => {
    if (!path) return "";
    const base = API_BASE.replace(/\/api\/?$/, ''); 
    const cleanPath = path.replace(/^\//, ''); 
    return `${base}/${cleanPath}`;
  };

  // ✅ SAFELY HANDLE 'logo' OR 'Logo'
  const mainLogoPath = companyDetails?.logo || companyDetails?.Logo;
  const ayushmanLogoPath = companyDetails?.ayushmanLogo || companyDetails?.AyushmanLogo;

  return (
    <>
      <style>{`
        :root {
          --marg-border: 1px solid #000;
          --marg-border-thick: 2px solid #000;
          --marg-font: Arial, Helvetica, sans-serif;
        }

        .marg-receipt-wrapper {
          font-family: var(--marg-font);
          color: #000;
          background: #fff;
          font-size: 12px;
        }

        .marg-outer-box {
          border: var(--marg-border-thick);
          margin-bottom: 20px;
          height: 265mm; 
          max-height: 265mm;
          box-sizing: border-box;
          position: relative;
          background: #fff;
          display: flex;
          flex-direction: column;
          page-break-inside: avoid;
          overflow: hidden;
        }

        .watermark-bg {
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 350px; 
          opacity: 0.08; 
          pointer-events: none; 
          z-index: 0;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .marg-header, .marg-title-strip, .marg-patient-box, .marg-rx-container, .marg-signature-box {
          position: relative;
          z-index: 1;
        }

        .marg-header {
          border-bottom: var(--marg-border-thick);
          padding: 5px 15px;
          text-align: center;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #fff; 
        }
        
        .marg-title-strip {
          background: #f0f0f0;
          border-bottom: var(--marg-border-thick);
          padding: 4px 15px;
          font-weight: 900;
          font-size: 14px;
          letter-spacing: 1px;
          text-align: center;
        }

        .marg-patient-box {
          display: flex;
          border-bottom: var(--marg-border-thick);
        }

        .marg-patient-col { padding: 5px 10px; }
        .marg-patient-left { width: 60%; border-right: 2px solid #000; }
        .marg-patient-right { width: 40%; }

        .marg-patient-col table {
          width: 100%;
          font-size: 12px;
          line-height: 1.5;
        }
        .marg-patient-col table td { vertical-align: top; }

        .marg-rx-container {
          flex-grow: 1; 
          display: flex;
          border-bottom: var(--marg-border-thick);
        }

        .marg-rx-left {
          width: 25%;
          border-right: var(--marg-border-thick);
          padding: 10px;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .marg-rx-right {
          width: 75%;
          padding: 15px 20px;
          display: flex;
          flex-direction: column;
        }

        .rx-symbol {
          font-size: 38px;
          font-weight: bold;
          font-family: "Times New Roman", serif;
          line-height: 1;
          color: #000;
          margin-bottom: 10px;
        }

        /* ✅ Medico Legal Note - Rx box ke bottom right me */
        .marg-medico-legal {
          margin-top: auto;
          text-align: right;
          color: #ff0000;
          font-weight: bold;
          font-style: italic;
          font-size: 11px;
          padding-top: 10px;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .marg-vitals-table { width: 100%; font-size: 12px; }
        .marg-vitals-table td { padding: 3px 0; }
        .marg-vitals-val { border-bottom: 1px dotted #000; padding-left: 3px; font-weight: bold; font-size: 11px; }

        .marg-section-title {
          font-weight: bold;
          text-transform: uppercase;
          text-decoration: underline;
          font-size: 12px;
          margin-bottom: 6px;
        }

        .marg-signature-box {
          display: flex;
          justify-content: space-between;
          padding: 20px 25px 10px 25px;
          height: 70px;
          align-items: flex-end;
        }

        .marg-sig-line {
          border-top: 1px solid #000;
          padding-top: 5px;
          text-align: center;
          font-weight: bold;
          font-size: 12px;
          width: 100%;
        }

        /* ✅ Dynamic Footer Text Styling for 500 words */
        .marg-footer-text {
          padding: 10px 15px;
          font-size: 11px; /* Thoda bada aur readable font */
          line-height: 1.5; /* Paragraphs aur lines ke beech me acchi spacing */
          text-align: center; /* Center aligned for a professional T&C look */
          white-space: pre-wrap; /* Agar text me paragraph change hai, toh wo sahi se dikhega */
          word-wrap: break-word;
          background: #fff;
          z-index: 1;
          border-top: 1px solid #000; /* Ek separator line jisse footer alag dikhe */
        }

        @media print {
          /* ✅ Uniform 5mm safe margin - top cut khatam, edge clip nahi hoga */
          @page { size: A4 portrait; margin: 5mm; }

          html, body {
            height: auto !important; overflow: visible !important;
            background: white !important; margin: 0 !important; padding: 0 !important;
          }
          body * { visibility: hidden; }
          #marg-print-section, #marg-print-section * { visibility: visible; }

          /* ✅ Print me wrapper ka p-2 padding zero kiya */
          #marg-print-section { 
            position: absolute; left: 0; top: 0; width: 100%; 
            margin: 0 !important; padding: 0 !important; 
          }

          /* ✅ Box ko printable area (297 - 10 = 287mm) fill karwaya, 1mm slack page-2 se bachne ke liye */
          .marg-outer-box {
            height: 286mm !important;
            max-height: 286mm !important;
            margin-bottom: 0 !important;
          }

          .modal, .modal-dialog, .modal-content { border: none !important; box-shadow: none !important; background: transparent !important; padding: 0 !important; }
          .no-print { display: none !important; }
          .marg-title-strip { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .watermark-bg { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .marg-medico-legal { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      `}</style>

      <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }}>
        <div className="modal-dialog modal-lg" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="modal-content border-0">
            
            <div id="marg-print-section" className="marg-receipt-wrapper p-2 bg-white">
              <div className="marg-outer-box">
                
      {mainLogoPath && <img src={getImageUrl(mainLogoPath)} alt="watermark" className="watermark-bg" />}

                {/* --- Header --- */}
                {showHeader ? (
                  <div className="marg-header">
                    {/* ✅ Main logo size bada kiya */}
                    <div style={{ width: '140px', height: '100px', display: 'flex', alignItems: 'center' }}>
                   {mainLogoPath && (
  <img 
    src={getImageUrl(mainLogoPath)}
    alt="Logo" 
    style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }} 
  />
)}
                    </div>
                    
                    <div style={{ flexGrow: 1, padding: '0 15px' }}>
                      <h2 style={{ margin: '0 0 4px 0', fontWeight: '900', fontSize: '24px', textTransform: 'uppercase', color: '#ff0000' }}>
                        {companyDetails.company_Name}
                      </h2>
                      <p style={{ margin: '0', fontSize: '13px' }}>{companyDetails.address}</p>
                      <p style={{ margin: '2px 0 0 0', fontSize: '12px' }}>
  <strong>Ph:</strong> {companyDetails.contact1}
  {companyDetails.contact2 && <>, {companyDetails.contact2}</>}
  &nbsp;|&nbsp; <strong>Email:</strong> {companyDetails.email_ID}
</p>
                      
                      {companyDetails.reg_No && companyDetails.reg_No.trim() !== "" && (
                         <p style={{ margin: '2px 0 0 0', fontSize: '12px' }}>
                           <strong>Reg No:</strong> {companyDetails.reg_No}
                         </p>
                      )}
                    </div>
                    
                   {/* ✅ Ayushman logo size bada kiya */}
                   <div style={{ width: '160px', textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
               {companyDetails?.isAyushmanActive && ayushmanLogoPath && (
                            <img 
                                src={getImageUrl(ayushmanLogoPath)} 
                                alt="Ayushman" 
                                style={{ width: '155px', maxHeight: '100px', objectFit: 'contain' }} 
                            />
                          )}
                </div>
                  </div>
                ) : (
                  <div style={{ height: "125px" }}></div>
                )}

                {/* --- Title Strip (Centered) --- */}
                <div className="marg-title-strip">
                  PRESCRIPTION / CONSULTATION
                </div>

                {/* --- Patient Info Box --- */}
                <div className="marg-patient-box">
                  <div className="marg-patient-col marg-patient-left">
                    <table>
                      <tbody>
                        <tr>
                          <td width="20%"><strong>Patient</strong></td>
                          <td width="5%">:</td>
                          <td><strong style={{ fontSize: '14px', textTransform: 'uppercase' }}>{patientName}</strong></td>
                        </tr>
                        <tr>
                          <td><strong>UHID No.</strong></td>
                          <td>:</td>
                          <td>{uhid}</td>
                        </tr>
                        <tr>
                          <td><strong>Address</strong></td>
                          <td>:</td>
                          <td>{data.address || "-"}</td>
                        </tr>
                        <tr>
                          <td><strong>Doctor</strong></td>
                          <td>:</td>
                          <td><strong>{doctorName}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <div className="marg-patient-col marg-patient-right">
                    <table style={{ width: '100%' }}>
                      <tbody>
                        {/* --- Combined OPD/IPD ID and DSR No --- */}
        <tr>
          {/* Label ke width ko thoda kam kiya (40%) taaki values ko jagah mil sake */}
          <td width="40%" style={{ textAlign: 'right' }}><strong>{receiptLabel}</strong></td>
          <td width="5%" style={{ textAlign: 'center' }}>:</td>
          <td style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
            <strong style={{ fontSize: '14px' }}>{receiptNo}</strong>
            
            {/* DSR No ko thik bagal me ek chhote se badge/box me dikhaya hai */}
            {(data.dailySrNo ?? data.DailySrNo) ? (
              <span style={{ 
                marginLeft: '10px', 
                padding: '2px 5px', 
                border: '1px solid #000', 
                borderRadius: '4px', 
                fontSize: '13px',
                backgroundColor: '#f8f9fa'
              }}>
                <strong>DSR: {data.dailySrNo ?? data.DailySrNo}</strong>
              </span>
            ) : null}
          </td>
        </tr>
                        <tr>
                          <td style={{ textAlign: 'right' }}><strong>Date</strong></td>
                          <td style={{ textAlign: 'center' }}>:</td>
                          <td style={{ textAlign: 'left' }}>{regDateFormatted}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'right' }}><strong>Age/Sex</strong></td>
                          <td style={{ textAlign: 'center' }}>:</td>
                          <td style={{ textAlign: 'left' }}>{ageGender}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'right' }}><strong>Mobile No.</strong></td>
                          <td style={{ textAlign: 'center' }}>:</td>
                          <td style={{ textAlign: 'left' }}>{mobile}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* --- Main Content (Split View) --- */}
                <div className="marg-rx-container">
                  
                  {/* Left Side (25%): Vitals & Investigations */}
                  <div className="marg-rx-left">
                    <div>
                      <div className="marg-section-title">VITALS</div>
                     <table className="marg-vitals-table">
                      <tbody>
                        {vitals.BP && <tr><td width="35%">BP</td><td width="5%">:</td><td className="marg-vitals-val">{vitals.BP} mmHg</td></tr>}
                        {vitals.Pulse && <tr><td>Pulse</td><td>:</td><td className="marg-vitals-val">{vitals.Pulse} b/min</td></tr>}
                        {vitals.SPO2 && <tr><td>SpO2</td><td>:</td><td className="marg-vitals-val">{vitals.SPO2} %</td></tr>}
                        {vitals.Temp && <tr><td>Temp</td><td>:</td><td className="marg-vitals-val">{vitals.Temp}</td></tr>}
                        {vitals.Weight && <tr><td>Weight</td><td>:</td><td className="marg-vitals-val">{vitals.Weight} kg</td></tr>}
                        {vitals.Height && <tr><td>Height</td><td>:</td><td className="marg-vitals-val">{vitals.Height} cm</td></tr>}
                        {vitals.RBS && <tr><td>RBS</td><td>:</td><td className="marg-vitals-val">{vitals.RBS}</td></tr>}
                      </tbody>
                    </table>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                      <div className="marg-section-title">INVESTIGATIONS</div>
                      {/* ✅ Doctor name yahan se hata diya gaya */}
                    </div>
                  </div>

                  {/* Right Side (75%): Complaints, PROV DX, Diagnosis, Rx */}
                  <div className="marg-rx-right">
                    <div>
                      <div className="marg-section-title">CHIEF COMPLAINTS</div>
                      <p style={{ margin: 0, fontSize: '13px', fontStyle: 'italic' }}>
                        {data.problems || data.appointmentReason || ""}
                      </p>
                    </div>

                    <div style={{ height: '30px' }}></div>

                    <div>
                      <div className="marg-section-title">PROV DX</div>
                    </div>

                    <div style={{ height: '30px' }}></div>

                    <div>
                      <div className="marg-section-title">DIAGNOSIS</div>
                    </div>

                    <div style={{ height: '40px' }}></div>

                    <div className="rx-symbol">Rx</div>

                    {/* ✅ Rx box ke bottom-right me red medico legal note */}
                    <div className="marg-medico-legal">
                      Not For Medico Legal Purpose
                    </div>
                    
                  </div>
                </div>

                {/* ✅ FOOTER TEXT BLOCK RENDERED CONDITIONAL ON DATA */}
                {currentFooterText && (
                  <div className="marg-footer-text">
                    {currentFooterText}
                  </div>
                )}

              </div>
            </div>

            {/* --- ACTION BUTTONS (No Print) --- */}
            <div className="no-print d-flex justify-content-end gap-2 mt-2 pt-2 border-top bg-light p-3 rounded-bottom">
              <button 
                  className={`btn ${showHeader ? "btn-outline-secondary" : "btn-warning"} fw-medium px-3`} 
                  onClick={handleToggleHeader}
              >
                <i className={`bi ${showHeader ? "bi-eye-slash" : "bi-eye"} me-2`}></i>
                {showHeader ? "Use Letterhead (Hide Header)" : "Show Header"}
              </button>
              <button className="btn btn-secondary px-4" onClick={onClose}>Close</button>
              <button className="btn btn-primary px-4 fw-bold" onClick={handlePrint} style={{ background: 'var(--theme-color, #0088cc)', borderColor: 'var(--theme-color, #0088cc)' }}>
                  <i className="bi bi-printer me-2"></i> Print
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Receipt;